import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  shareItem: {
    title: null,
    image: null,
  },
};

const shareItemSlice = createSlice({
  name: "shareItem",
  initialState,
  reducers: {
    setShareItem(state, { payload }) {
      state.shareItem = payload;
    },
  },
});

export const { setShareItem } = shareItemSlice.actions;

export default shareItemSlice.reducer;
